// extracted by mini-css-extract-plugin
export default {"avatarGroup":"avatarGroup_avatarGroup__EhfZg","avatar":"avatarGroup_avatar__oc7ap","accessToOnlyOne":"avatarGroup_accessToOnlyOne__UriMV"};